<template>
    <div>
        <gmap-map ref="gmap"
            :center="center"
            :zoom="2.2"
            :options="{minZoom: 2}"
            style="margin: auto; width:95%;  min-height: 70vh; border: 1px black solid; border-radius: 1em; overflow: hidden;"
        >
          <template v-if="shipment && shipment.positions">
            <gmap-marker
                v-if="shipment"
                :position="{lat: shipment.positions[0].latitude, lng: shipment.positions[0].longitude}"
                icon="/static/img/final-point.png"
            ></gmap-marker>
            <gmap-marker
                v-if="shipment && shipment.positions && shipment.positions.length"
                :position="{lat: shipment.positions[shipment.positions.length-1].latitude, lng: shipment.positions[shipment.positions.length-1].longitude}"
                icon="/static/img/point.png"
            ></gmap-marker>
          </template>
            <gmap-polyline v-bind:path.sync="positions" v-bind:options="{ strokeColor:'#009c95', strokeOpacity: 0.7}"/>
        </gmap-map>
    </div>
</template>

<script>
export default {
  name: 'mapLocations',
  props: ['shipment'],
  created () {
  },
  mounted () {
    this.$emit('loading')
    this.$refs.gmap.$mapPromise.then((map) => {
    }).then(() => { this.$emit('loaded') })
  },
  data () {
    return {
      filters: {},
      health: '',
      shipments: [],
      center: { lat: 45.508, lng: -73.587 },
      markerImg: '',
      currentPlace: null,
      place: {},
      showInfo: false
    }
  },
  methods: {
    setBounds () {
      // eslint-disable-next-line
      var bounds = new google.maps.LatLngBounds()
      this.positions.forEach(position => {
        bounds.extend(position)
      })
      this.$refs.gmap.$mapPromise.then((map) => {
        // eslint-disable-next-line
        google.maps.event.addListener(map, 'zoom_changed', () => {
          var zoomChangeBoundsListener =
            // eslint-disable-next-line
            google.maps.event.addListener(map, 'bounds_changed', (event) => {
              if (map.getZoom() > 8 && map.initialZoom) {
                // Change max/min zoom here
                map.setZoom(8)
                map.initialZoom = false
              }
              // eslint-disable-next-line
              google.maps.event.removeListener(zoomChangeBoundsListener)
            })
        })
        map.initialZoom = true
        map.fitBounds(bounds)
      })
    }
  },
  computed: {
    positions () {
      if (this.shipment && this.shipment.positions) {
        return this.shipment.positions.map((x) => { return {lat: x.latitude, lng: x.longitude} })
      } else {
        return []
      }
    }
  },
  watch: {
    positions () {
      this.setBounds()
    }
  }
}
</script>
<style lang="scss">
.modal-container{
  overflow: auto;
  max-height: 95vh;
}

</style>



// WEBPACK FOOTER //
// src/components/ShipmentMap.vue